import axios from "axios"

import { SecurityObject } from "~/domain/user-session"
import { api } from "~/shared/api"

export async function hasAccessTo(
	objects: string | SecurityObject | SecurityObject[],
	secureOp: "and" | "or" = "and",
) {
	try {
		await api.post("/security/auth/has-access-to/v2", { accessObjects: objects, secureOp })
	} catch (err) {
		if (axios.isAxiosError(err)) {
			if (secureOp === "and") {
				const objectIndex: number | undefined =
					err.response?.data?.objectIndex
				return objectIndex ?? false
			} else {
				return false
			}
		}
	}

	return true
}
